import axios from 'axios'
import router from '../router'

axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';

export default ({
    namespaced: true,
    state: {
        token: null,
        user: null,
        errors: null,
        messages: null,
        loading: false
    },

    getters:{
        authenticated(state){
            return state.token && state.user
        },
        passwordChanged(state){
            return state.user.password_modified ? true : false
        },
        user(state){
            return state.user
        },
        errors(state){
            return state.errors
        },
        loading(state){
            return state.loading
        },
        messages(state){
            return state.messages
        }

    },

    mutations: {
        SET_TOKEN(state, token) {
            state.token = token
        },
        SET_USER(state, data) {
            state.user = data
        },
        SET_ERRORS(state, data) {
            state.errors = data
        },
        SET_MESSAGES(state, data) {
            state.messages = data
        },
        SET_LOADING(state, data) {
            state.loading = data
        },
    },

    actions: {
        async signUp({dispatch}, credentials) {
            try {
                let response = await axios.post('auth/register', credentials)
                router.replace({
                    name: 'auth.login'
                })
                return response.data.message
            } catch (e) {
                dispatch('setAuthErrors', e.response.data )
                throw Error;
            }
        },

        async signIn({dispatch}, credentials) {
            dispatch('setLoading')
            try {
                let response = await axios.post('auth/login', credentials)
                return dispatch('attempt', response.data.token )
            } catch (e) {
                dispatch('setAuthErrors', e.response.data )
                throw Error;
            } finally {
                dispatch('clearLoading')
            }
        },

        async recover({dispatch}, credentials) {
            try {
                let response = await axios.post('auth/recover', credentials)
                return response.data.message
            } catch (e) {
                dispatch('setAuthErrors', e.response.data )
                throw Error;
            }
        },

        async attempt ({commit, dispatch, state}, token) {
            dispatch('setLoading')
            if ( token ) {
                commit('SET_TOKEN', token)
            }
            if ( !state.token ) {
                return
            }
            try {
                let response = await axios.get('auth/profile')
                commit('SET_USER', response.data)
                dispatch('customer/getCustomer', null, { root: true } )
                dispatch('accountStatus/getAccountStatus', null, { root: true } )
                router.replace({
                    name: 'home'
                })

            } catch (e) {
                // let response = await axios.get('email/resend', e.response.data)
                commit('SET_TOKEN', null)
                commit('SET_USER', null)
                dispatch('setAuthErrors', e.response.data )
                router.go(-1)
            } finally {
                dispatch('clearLoading')
            }
        },

        async updateUser({commit, state, dispatch}, data) {
            try {
                let response = await axios.put(`user/${state.user.id}`, data)
                commit('SET_MESSAGES', response.data.message)
                commit('SET_USER', response.data.user)
                setTimeout(() =>
                    commit('auth/SET_MESSAGES', null, { root: true }),
                3000);
                return response.data.message
            } catch (e) {
                dispatch('setAuthErrors', e.response.data )
                throw Error;
            }
        },

        async changePassword({commit, state, dispatch}, data) {
            try {
                let response = await axios.put(`credentials/change/${state.user.id}`, data)
                commit('SET_MESSAGES', response.data.message)
                commit('SET_USER', response.data.user)
                setTimeout(() =>
                    commit('auth/SET_MESSAGES', null, { root: true }),
                3000);
                return response.data.message
            } catch (e) {
                dispatch('setAuthErrors', e.response.data )
                throw Error;
            }
        },

        signOut({commit}) {
            return axios.post('auth/logout').then(() => {
                commit('SET_TOKEN', null)
                commit('SET_USER', null)
                setTimeout(() =>
                    window.location = "https://bambi.com.ar/",
                2000);
            })
        },

        setAuthErrors({commit, dispatch}, message) {
            commit('SET_ERRORS', message)
            setTimeout(() =>
                dispatch('clearAuthErrors'),
            3000);
        },

        setAuthMessage({commit, dispatch}, message) {
            commit('SET_MESSAGES', message)
            setTimeout(() =>
                dispatch('clearAuthMessages'),
            3000);
        },

        clearAuthErrors({commit}) {
            commit('SET_ERRORS', null)
        },

        clearAuthMessages({commit}) {
            commit('SET_MESSAGES', null)
        },

        setLoading({commit}) {
            commit('SET_LOADING', true)
        },

        clearLoading({commit}) {
            commit('SET_LOADING', false)
        }
    }
})

